module.exports = __webpack_public_path__ + "static/media/foot-icon.ef4c901c.svg";